import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { ApplicationRoute } from '../../constants';

function setupDashboard(): void {
  applicationModuleRegistry.register({
    entry: 'dashboard',
    id: 'dashboard',
    name: 'modules.dashboard',
    route: ApplicationRoute.DASHBOARD,
  });
}

export {
  setupDashboard,
};
